import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            全网热议话题实时热度排行，看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center max-w-[900px] mx-auto">
          {topics.map((topic, idx) => (
            <div
              key={topic.id}
              className="group cursor-pointer flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all"
            >
              <span
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                  idx < 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {idx + 1}
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}